module.exports = __webpack_public_path__ + "img/temprature.beb79815.svg";